import script from "./ListarVideoaulas.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarVideoaulas.vue?vue&type=script&setup=true&lang=js"

import "./ListarVideoaulas.vue?vue&type=style&index=0&id=55fbb9d1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55fbb9d1"]])

export default __exports__